export function isNullOrUndefined(value) {
  return (value === null) || (value === undefined);
}



// WEBPACK FOOTER //
// ./src/app/services/utils/is-null-or-undefined.ts